import { createContext, useContext } from 'react';
/**
 * CCMS Context for React applications
 */
export const CCMSContext = createContext(null);
/**
 * Hook to access CCMS SDK clients
 * Must be used within a CCMSProvider
 */
export function useCCMS() {
    const context = useContext(CCMSContext);
    if (!context) {
        throw new Error('useCCMS must be used within a CCMSProvider');
    }
    return context;
}
/**
 * Hook to access HTTP client
 */
export function useHttpClient() {
    const { http } = useCCMS();
    return http;
}
/**
 * Hook to access Presence client from CCMSProvider
 * @throws {Error} If presence not configured in CCMSProvider
 */
export function usePresenceClient() {
    const { presence } = useCCMS();
    if (!presence) {
        throw new Error('Presence client not available. Add presenceUrl to CCMSProvider config.');
    }
    return presence;
}
/**
 * Hook to access Stock client from CCMSProvider
 * @throws {Error} If stock hub not configured in CCMSProvider
 */
export function useStockClient() {
    const { stock } = useCCMS();
    if (!stock) {
        throw new Error('Stock client not available. Add stockHubUrl to CCMSProvider config.');
    }
    return stock;
}
//# sourceMappingURL=useCCMS.js.map